/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import productFlowService from './../../../../services/productFlow';
import productFlowTransformer from './../../../../transformers/productFlow';
import Forms from './../../../../utils/forms/forms';
import productService from './../../../../services/product';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        title: {
          value: '',
          type: 'text',
        },
        descriptions: {
          value: '',
          type: 'textarea',
        },
        orderId: {
          value: '',
          type: 'select',
        },
        productId: {
          value: '',
          type: 'select',
        },
        qty: {
          value:'',
          type: 'number',
        }
      }),
      loading: true,
      tabIndex: 'first',
     
    };
  },

  computed: {
    ...mapGetters({
      productFlow:'currentproductFlow',
      products: 'allProducts',
      orders: 'allproductFlowOrders'
    }),
    
  },

  watch: {
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} products    The products list.
     */
    products(products) {
      this.formBasicInformation.setOptions('productId', products.map(c => (
              { id: c.id, name:`${c.name }` }
      )));  
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} products    The products list.
     */
    orders(orders) {
      console.log(orders);
      this.formBasicInformation.setOptions('orderId', orders.map(c => (
              { id: c.id, name:`${c.name }` }
      )));  
    },

  },

  created() {
    this.show();
  },

  methods: {
    /**
     * Method to store the client
     */
    update() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const supp = productFlowTransformer.send(
        Object.assign({}, this.formBasicInformation.data())
      );
      console.log(supp);
      productFlowService.update(this.$route.params.id, supp)
      .then(() => {
        this.$message({
          message: this.$t('static.productFlow.update.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'productFlow.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formBasicInformation.recordErrors(errors);
      });
    },

    /**
     * Fetches the productFlow object for editing.
     */
    show() {
      this.loading = true;
      Promise.all([
        productFlowService.show(this.$route.params.id),
        productService.all(),
        productFlowService.orders(),
      ]).then((data) => {
        this.loading = false;
        const ware = data[0]
        this.formBasicInformation.assignData(ware);
        this.formBasicInformation.disableField('orderId');
        //this.formBasicInformation.disableField('number');
        console.log(this.productList);
      });
    },
    link(productFlow) {
      const routeData = this.$router.resolve({
        params: { id: productFlow.productFlowId },
        name: 'productFlow.edit',
      });
      window.open(routeData.href, '_blank');
    },
    transactionLink(trans) {
       var name = '';
       if(trans.via == 'Stock count'){
         name = 'inventory.stock.view'
       }else if(trans.via == 'Stock Adjustment'){
         name = 'inventory.adjustment.view'
       }else if(trans.via == 'Order'){
         name = 'orders.edit'
       }else if(trans.via == 'Purchase'){
         name = 'inventory.purchase.view';
       }
       console.log(name);
      const routeData = this.$router.resolve({
        params: { id: trans.id },
        name,
      });
      window.open(routeData.href, '_blank');
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productFlow/edit/edit.js